<script lang="ts">
    import { fade } from 'svelte/transition'
    import { showMessageStore as showMessage } from '../../../stores' 
    
    // @see store for automatic timeout of value
    
    let fadeOutDuration = 500
    showMessage.subscribe((message) => {
        if(message) {
            fadeOutDuration = message?.durationMs ? 500 : 0
        }
    })
</script>

{#if $showMessage}
    <div class="auction-message" out:fade="{{ duration: fadeOutDuration }}">
        <p>{$showMessage.text}</p>
    </div>
{/if}